if (!customElements.get('yc-image-player')) {
  class YCImagePlayer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.videoDesktop = this.querySelector('.yc-image-player__video--desktop');
      this.videoMobile = this.querySelector('.yc-image-player__video--mobile');
      this.allVideos = this.querySelectorAll('.yc-image-player__video');
      this.mediaContainer = this.querySelector('.yc-image-player__media');
      this.progressBar = this.querySelector('.yc-image-player__progress-bar');
      this.progressFill = this.querySelector('.yc-image-player__progress');
      this.timeDisplay = this.querySelector('.yc-image-player__time');

      this.initPlayer();
    }

    getActiveVideo() {
      if (this.videoDesktop && window.getComputedStyle(this.videoDesktop).display !== 'none') {
        return this.videoDesktop;
      }
      if (this.videoMobile && window.getComputedStyle(this.videoMobile).display !== 'none') {
        return this.videoMobile;
      }
      return this.videoDesktop || this.videoMobile;
    }

    formatTime(seconds) {
      if (isNaN(seconds) || !isFinite(seconds)) return '00:00';
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60);
      return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }

    updateTime = () => {
      if (!this.activeVideo) return;
      const current = this.activeVideo.currentTime;
      const duration = this.activeVideo.duration || 0;
      
      if (duration > 0 && this.progressFill) {
        const percent = (current / duration) * 100;
        this.progressFill.style.width = percent + '%';
      }
      
      if (this.timeDisplay) {
        this.timeDisplay.innerHTML = this.formatTime(current) + '/<span>' + this.formatTime(duration) + '</span>';
      }
    }

    initPlayer() {
      this.activeVideo = this.getActiveVideo();
      if (!this.activeVideo || !this.mediaContainer) return;

      this.activeVideo.addEventListener('loadedmetadata', this.updateTime);
      this.activeVideo.addEventListener('timeupdate', this.updateTime);
      
      if (this.activeVideo.readyState >= 1) {
        this.updateTime();
      }

      this.mediaContainer.addEventListener('click', () => {
        if (this.activeVideo.paused) {
          this.allVideos.forEach(v => {
            if (v !== this.activeVideo) v.pause();
          });
          this.activeVideo.play();
          this.mediaContainer.classList.add('is-playing');
        } else {
          this.activeVideo.pause();
          this.mediaContainer.classList.remove('is-playing');
        }
      });

      this.activeVideo.addEventListener('ended', () => {
        this.mediaContainer.classList.remove('is-playing');
      });

      if (this.progressBar) {
        this.progressBar.addEventListener('click', (e) => {
          const rect = this.progressBar.getBoundingClientRect();
          const pos = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
          if (this.activeVideo.duration) {
            this.activeVideo.currentTime = pos * this.activeVideo.duration;
            this.updateTime();
          }
        });
      }
      
      // Update active video on resize
      window.addEventListener('resize', () => {
        const newActiveVideo = this.getActiveVideo();
        if (newActiveVideo !== this.activeVideo) {
          if (!this.activeVideo.paused) {
            this.activeVideo.pause();
            this.mediaContainer.classList.remove('is-playing');
          }
          this.activeVideo.removeEventListener('loadedmetadata', this.updateTime);
          this.activeVideo.removeEventListener('timeupdate', this.updateTime);
          this.activeVideo.removeEventListener('ended', () => this.mediaContainer.classList.remove('is-playing'));
          
          this.activeVideo = newActiveVideo;
          
          this.activeVideo.addEventListener('loadedmetadata', this.updateTime);
          this.activeVideo.addEventListener('timeupdate', this.updateTime);
          this.activeVideo.addEventListener('ended', () => this.mediaContainer.classList.remove('is-playing'));
          
          this.updateTime();
        }
      });
    }
  }

  customElements.define('yc-image-player', YCImagePlayer);
}
